<template>
	<div>
		<el-tabs type="border-card" class="maintab" style="overflow: auto">
			<el-tab-pane>
				<span slot="label"><i class="el-icon-bangzhu"></i> 耗材种类设置</span>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-table
							:data="supClassList"
							ref="supClassTable"
							height="700"
							border
							style="width: 620px"
							v-loading="supClassListloading"
							element-loading-text="拼命加载中"
							element-loading-spinner="el-icon-loading"
							element-loading-background="rgba(255, 255, 255, 0.8)">
							<el-table-column prop="scId" label="类型ID" width="90">
							</el-table-column>
							<el-table-column prop="scName" label="类型名称" width="200">
								<template slot-scope="scope">
									<el-input size="mini" v-model="scope.row.scName"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="createTime" label="创建时间" width="200">
								<template slot-scope="scope">
									<el-tag size="mini" type="warning">{{
										scope.row.createTime | dateformatAll("YYYY-MM-DD HH:mm:ss")
									}}</el-tag>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="110">
								<template slot-scope="scope">
									<el-button
										type="primary"
										size="mini"
										@click="UpdateSupClass(scope.row)"
										><i class="el-icon-refresh"></i>&nbsp;更新</el-button
									>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="2"> &nbsp; </el-col>
					<el-col :span="10">
						<h2 style="margin: 5px auto">新增耗材类型</h2>
						<p>
							<el-input
								style="width: 250px; margin-right: 20px"
								placeholder="新增耗材类型名称"
								clearable
								v-model="addSupClass"
								:maxlength="10"
								show-word-limit></el-input>
							<el-button type="primary" @click="addNewSupClass"
								><i class="el-icon-plus"></i>&nbsp;新增</el-button
							>
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane>
				<span slot="label"><i class="el-icon-aim"></i> 耗材单位设置</span>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-table
							:data="supUnitList"
							ref="supUnitTable"
							height="700"
							border
							style="width: 620px"
							v-loading="supUnitListLoading"
							element-loading-text="拼命加载中"
							element-loading-spinner="el-icon-loading"
							element-loading-background="rgba(255, 255, 255, 0.8)">
							<el-table-column prop="suId" label="单位ID" width="90">
							</el-table-column>
							<el-table-column prop="suName" label="单位名称" width="200">
								<template slot-scope="scope">
									<el-input size="mini" v-model="scope.row.suName"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="createTime" label="创建时间" width="200">
								<template slot-scope="scope">
									<el-tag size="mini" type="success">{{
										scope.row.createTime | dateformatAll("YYYY-MM-DD HH:mm:ss")
									}}</el-tag>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="110">
								<template slot-scope="scope">
									<el-button
										type="warning"
										size="mini"
										@click="UpdateSupUnit(scope.row)"
										><i class="el-icon-refresh"></i>&nbsp;更新</el-button
									>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="2"> &nbsp; </el-col>
					<el-col :span="10">
						<h2 style="margin: 5px auto">新增耗材单位</h2>
						<p>
							<el-input
								style="width: 250px; margin-right: 20px"
								placeholder="新增耗材单位名称"
								clearable
								v-model="addSupUnit"
								:maxlength="5"
								show-word-limit></el-input>
							<el-button type="warning" @click="addNewSupUnit"
								><i class="el-icon-plus"></i>&nbsp;新增</el-button
							>
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane>
				<span slot="label"
					><i class="el-icon-takeaway-box"></i> 领用部门设置</span
				>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-table
							:data="supDepList"
							ref="supDepTable"
							height="700"
							border
							style="width: 620px"
							v-loading="supDepListLoading"
							element-loading-text="拼命加载中"
							element-loading-spinner="el-icon-loading"
							element-loading-background="rgba(255, 255, 255, 0.8)">
							<el-table-column prop="sdId" label="部门ID" width="90">
							</el-table-column>
							<el-table-column
								prop="sdName"
								label="部门名称"
								width="200"
								show-overflow-tooltip>
								<template slot-scope="scope">
									<el-input size="mini" v-model="scope.row.sdName"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="createTime" label="创建时间" width="200">
								<template slot-scope="scope">
									<el-tag size="mini" type="primary">{{
										scope.row.createTime | dateformatAll("YYYY-MM-DD HH:mm:ss")
									}}</el-tag>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="110">
								<template slot-scope="scope">
									<el-button
										type="success"
										size="mini"
										@click="updateSupDep(scope.row)"
										><i class="el-icon-refresh"></i>&nbsp;更新</el-button
									>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="2"> &nbsp; </el-col>
					<el-col :span="10">
						<h2 style="margin: 5px auto">新增领用部门</h2>
						<p>
							<el-input
								style="width: 250px; margin-right: 20px"
								placeholder="新增领用部门名称"
								clearable
								v-model="addSupDep"
								:maxlength="15"
								show-word-limit></el-input>
							<el-button type="success" @click="addNewSupDep"
								><i class="el-icon-plus"></i>&nbsp;新增</el-button
							>
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
export default {
	name: "suppliesConfig",
	data() {
		return {
			supClassList: [], //耗材类型列表
			supUnitList: [], //耗材单位表
			supDepList: [], //领用部门表
			supClassListloading: false, //耗材类型列表加载动画
			supUnitListLoading: false, //耗材单位加载动画
			supDepListLoading: false, //领用部门加载动画
			addSupClass: "", //新增耗材类型
			addSupUnit: "", //新增耗材单位
			addSupDep: "", //新增领用部门
		}
	},
	mounted() {
		this.getSupClassList()
		this.getSupUnitList()
		this.getSupDepList()
	},
	methods: {
		//获取耗材类型列表
		async getSupClassList() {
			this.supClassListloading = true
			const { data: res } = await this.$http.post("/sup/supClassList").catch(err => err)
			if (res) {
				this.supClassList = res
			}
			this.supClassListloading = false
		},
		//获取耗材单位列表
		async getSupUnitList() {
			this.supUnitListLoading = true
			const { data: res } = await this.$http.post("/sup/supUnitList").catch(err => err)
			if (res) {
				this.supUnitList = res
			}
			this.supUnitListLoading = false
		},
		//获取领用部门列表
		async getSupDepList() {
			this.supDepListLoading = true
			const { data: res } = await this.$http.post("/sup/supDepList").catch(err => err)
			if (res) {
				this.supDepList = res
			}
			this.supDepListLoading = false
		},
		//更新耗材类型
		async UpdateSupClass(data) {
			//询问用户是否执行操作
			const confirmresult = await this.$confirm(
				"即将更新此条耗材类型名称，请确定是否继续",
				"提示",
				{
					confirmButtonText: "确定更新",
					cancelButtonText: "取消",
					type: "warning",
				}
			).catch(err => err)
			if (confirmresult !== "confirm") {
				return this.$message.info("已取消操作。")
			}
			const { data: res } = await this.$http.post("/sup/updateSupClass", data).catch(err => err)
			if (res) {
				this.$message.success("更新成功！")
				this.getSupClassList()
			}
		},
		//新增耗材类型
		async addNewSupClass() {
			if (
				this.addSupClass == null ||
				this.addSupClass == undefined ||
				this.addSupClass.trim() === ""
			) {
				this.$message.warning("新增的耗材类型不可为空！请重试")
			} else {
				const confirmresult = await this.$confirm(
					"即将新增耗材类型，请确定是否继续",
					"提示",
					{
						confirmButtonText: "确定新增",
						cancelButtonText: "取消",
						type: "warning",
					}
				).catch(err => err)
				if (confirmresult !== "confirm") {
					return this.$message.info("已取消操作。")
				}
				var addData = {
					data: this.addSupClass,
				}
				const { data: res } = await this.$http.post("/sup/addSupClass", addData).catch(err => err)
				if (res) {
					this.getSupClassList()
					this.addSupClass = ""
					this.$message.success("添加成功！")
				}
			}
		},
		//修改耗材单位
		async UpdateSupUnit(data) {
			//询问用户是否执行操作
			const confirmresult = await this.$confirm(
				"即将更新此条耗材单位名称，请确定是否继续",
				"提示",
				{
					confirmButtonText: "确定更新",
					cancelButtonText: "取消",
					type: "warning",
				}
			).catch(err => err)
			if (confirmresult !== "confirm") {
				return this.$message.info("已取消操作。")
			}
			const { data: res } = await this.$http.post("/sup/updateSupUnit", data).catch(err => err)
			if (res) {
				this.$message.success("更新成功！")
				this.getSupClassList()
			}
		},
		//新增耗材单位
		async addNewSupUnit() {
			if (
				this.addSupUnit == null ||
				this.addSupUnit == undefined ||
				this.addSupUnit.trim() === ""
			) {
				this.$message.warning("新增的耗材单位不可为空！请重试")
			} else {
				const confirmresult = await this.$confirm(
					"即将新增耗材单位，请确定是否继续",
					"提示",
					{
						confirmButtonText: "确定新增",
						cancelButtonText: "取消",
						type: "warning",
					}
				).catch(err => err)
				if (confirmresult !== "confirm") {
					return this.$message.info("已取消操作。")
				}
				var addData = {
					data: this.addSupUnit,
				}
				const { data: res } = await this.$http.post("/sup/addSupUnit", addData).catch(err => err)
				if (res) {
					this.getSupUnitList()
					this.addSupUnit = ""
					this.$message.success("添加成功！")
				}
			}
		},
		//更新领用部门
		async updateSupDep(data) {
			//询问用户是否执行操作
			const confirmresult = await this.$confirm(
				"即将更新此条领用部门名称，请确定是否继续",
				"提示",
				{
					confirmButtonText: "确定更新",
					cancelButtonText: "取消",
					type: "warning",
				}
			).catch(err => err)
			if (confirmresult !== "confirm") {
				return this.$message.info("已取消操作。")
			}
			const { data: res } = await this.$http.post("/sup/updateSupDep", data).catch(err => err)
			if (res) {
				this.$message.success("更新成功！")
				this.getSupClassList()
			}
		},
		//新增领用部门
		async addNewSupDep() {
			if (
				this.addSupDep == null ||
				this.addSupDep == undefined ||
				this.addSupDep.trim() === ""
			) {
				this.$message.warning("新增的领用部门不可为空！请重试")
			} else {
				const confirmresult = await this.$confirm(
					"即将新增领用部门，请确定是否继续",
					"提示",
					{
						confirmButtonText: "确定新增",
						cancelButtonText: "取消",
						type: "warning",
					}
				).catch(err => err)
				if (confirmresult !== "confirm") {
					return this.$message.info("已取消操作。")
				}
				var addData = {
					data: this.addSupDep,
				}
				const { data: res } = await this.$http.post("/sup/addSupDep", addData).catch(err => err)
				if (res) {
					this.getSupDepList()
					this.addSupDep = ""
					this.$message.success("添加成功！")
				}
			}
		},
	},
}
</script>

<style></style>
